// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { attributeKindEnum } from './AttributeKindEnum';
import { censoredProjectionEnum } from './CensoredProjectionEnum';
import { attributeCodeVisibilityEnum } from './AttributeCodeVisibilityEnum';
import { operatorId } from './Operator';
import { foodNutrientTypeId } from './FoodNutrientType';
import { z } from 'zod';
export const testAttributeCodeCode = z.string();
export const testAttributeCode = z.object({
    code: testAttributeCodeCode,
    description: z.string().nullable(),
    created_at: z.date(),
    name: z.string(),
    kind: attributeKindEnum,
    category: z.string().nullable(),
    censored_projection: censoredProjectionEnum,
    archived_at: z.date().nullable(),
    updated_at: z.date(),
    visibility: attributeCodeVisibilityEnum,
    units: z.string().array(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
    food_nutrient_type_id: foodNutrientTypeId.nullable(),
});
export const testAttributeCodeInitializer = z.object({
    code: testAttributeCodeCode,
    description: z.string().optional().nullable(),
    created_at: z.date().optional(),
    name: z.string(),
    kind: attributeKindEnum.optional(),
    category: z.string().optional().nullable(),
    censored_projection: censoredProjectionEnum.optional(),
    archived_at: z.date().optional().nullable(),
    updated_at: z.date().optional(),
    visibility: attributeCodeVisibilityEnum.optional(),
    units: z.string().array().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    food_nutrient_type_id: foodNutrientTypeId.optional().nullable(),
});
export const testAttributeCodeMutator = z.object({
    code: testAttributeCodeCode.optional(),
    description: z.string().optional().nullable(),
    created_at: z.date().optional(),
    name: z.string().optional(),
    kind: attributeKindEnum.optional(),
    category: z.string().optional().nullable(),
    censored_projection: censoredProjectionEnum.optional(),
    archived_at: z.date().optional().nullable(),
    updated_at: z.date().optional(),
    visibility: attributeCodeVisibilityEnum.optional(),
    units: z.string().array().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    food_nutrient_type_id: foodNutrientTypeId.optional().nullable(),
});
//# sourceMappingURL=TestAttributeCode.js.map